import React, { useEffect, useState } from 'react'
import { List, Box, Text } from 'grommet'
import UnifiedAlarmSummary from './UnifiedAlarmSummary'
import { I18n } from 'galarm-config'
import SearchBar from './SearchBar'

const RecentlyDeletedAlarmList = ({ alarms, showSearchBar, hideSearchBar }) => {
  const [searchText, setSearchText] = useState('')

  useEffect(() => {
    if (!showSearchBar) {
      setSearchText('')
    }
  }, [showSearchBar])

  let filteredAlarms = alarms.filter(
    alarm =>
      alarm.name.toLowerCase().includes(searchText.toLowerCase()) ||
      alarm.notes.toLowerCase().includes(searchText.toLowerCase())
  )

  return (
    <Box flex={{ shrink: 0 }}>
      <Text color="darkTint" margin={{ horizontal: 'medium', top: 'small' }}>
        {I18n.t('restoreAlarmsFromMobileApp')}
      </Text>
      {showSearchBar && (
        <SearchBar
          onChangeText={setSearchText}
          searchText={searchText}
          onCloseSearchBar={hideSearchBar}
          focus
        />
      )}
      {filteredAlarms.length === 0 ? (
        <Box pad="medium" flex justify="center" align="center">
          <Text color="textColor">{I18n.t('noRecentlyDeletedAlarms')}</Text>
        </Box>
      ) : (
        <List
          border={false}
          margin={{ vertical: 'small' }}
          pad={{ vertical: 'xsmall', horizontal: 'small' }}
          data={filteredAlarms}
          // eslint-disable-next-line react/no-children-prop
          children={UnifiedAlarmSummary}
        />
      )}
    </Box>
  )
}

export default RecentlyDeletedAlarmList
